import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MemoizedSelector, select, Store } from '@ngrx/store';
import { ResourceState, ResourceStatuses } from '@platform/shared/resource.state';
import { RootState } from '@root/app.state';

@Component({
  selector: 'app-widget-loading-spinner',
  templateUrl: './widget-loading-spinner.component.html',
  styleUrls: [],
})
export class WidgetLoadingSpinnerComponent implements OnInit {
  @Input() loadingHintTranslationKey!: string;
  @Input() selectorToWaitFor!: MemoizedSelector<object, ResourceState<any>>;
  @Input() ignoreWasPending = false;

  public succeeded = false;
  private wasPending = false;
  private destroyRef = inject(DestroyRef);

  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {
    this.store$.pipe(select(this.selectorToWaitFor), takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
      if (x.status === ResourceStatuses.PENDING) {
        this.succeeded = false;
        this.wasPending = true;
      } else if (x.status === ResourceStatuses.SUCCEEDED && (this.wasPending || this.ignoreWasPending)) {
        this.succeeded = true;
      }
    });
  }
}
